import type React from "react";

import type { RequireSome } from "@nephroflow/design-system";

import type { VariantProps } from "@nephroflow/design-system/styling/utils";
import { cn, cva } from "@nephroflow/design-system/styling/utils";

interface HeadingProps
  extends
    React.ButtonHTMLAttributes<HTMLHeadingElement>,
    React.RefAttributes<HTMLHeadingElement>,
    RequireSome<VariantProps<typeof headingVariants>, "level"> {}

export const Heading = ({ className, level, ref, ...props }: HeadingProps) => {
  const Comp = `h${level}` as "h1";

  return <Comp className={cn(headingVariants({ level }), className)} ref={ref} {...props} />;
};
(Heading as React.FC).displayName = "Heading";

const headingVariants = cva("font-medium", {
  variants: {
    level: {
      1: "text-4xl leading-16",
      2: "text-3xl leading-12",
      3: "text-2xl leading-10",
      4: "text-xl leading-8",
      5: "text-lg leading-base",
    },
  },
});
